export default __webpack_public_path__ + "static/media/banner1.842be008.jpg";